import styles from 'sections/danceShow/danceShowHero/danceShowHero.module.css';
import generalStyles from 'index.module.css';

import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { AnimatedPart } from 'components/animatedPart/AnimatedPart';

export const DanceShowHero = () => {
    const { t } = useTranslation();

    return (
        <section
            id="section-dance-show-hero"
            className={`${generalStyles.heightAuto} ${styles.danceShowSection}`}
        >
            <Element name="danceShowHero">
                <div className={styles.danceShow}>
                    <div className={styles.text}>
                        <AnimatedPart>
                            <h1 className={`${styles.heading} animated-items`}>
                                {t('danceShow.danceShowTitle')}
                            </h1>
                        </AnimatedPart>
                    </div>
                </div>

                <div className={generalStyles.container}>
                    <div className={styles.danceShow__info}>
                        <h2 className={styles.info__title}>
                            {t('danceShow.danceShowTitle')}
                        </h2>
                        <p className={styles.info__text}>
                            {t('danceShow.aChoreographedDanceTailored')}
                        </p>
                    </div>
                </div>
            </Element>
        </section>
    );
};
